<template>
  <v-col style="max-width: 900px">
    <br />
    <h1 class="left-align">
      {{ $t('documentation.titles.services.title') }}
    </h1>
    <br />
    <h2 class="left-align">
      {{ $t('documentation.titles.services.subsections.upgrade') }}
    </h2>

    <p class="left-align">
      {{ $t('documentation.texts.upgradeServices.paragraph1') }}
    </p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic1Name" />
    <br />
    <v-img style="width: 100%; max-width: 600px" contain :src="pic2Name" />
    <br />
    <v-img style="width: 100%; max-width: 600px" contain :src="pic3Name" />
    <br />
    <p class="left-align">
      {{ $t('documentation.texts.upgradeServices.paragraph2') }}
    </p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic4Name" />
    <p class="left-align">
      {{ $t('documentation.texts.upgradeServices.paragraph3') }}
    </p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic5Name" />
    <p class="left-align">
      {{ $t('documentation.texts.upgradeServices.paragraph4') }}
    </p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic6Name" />

    <br />
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['isAddaliaAdminUser']),
    pic1Name() {
      return require('@/assets/documentation/services/' +
        this.$t('documentation.texts.upgradeServices.picUpgradeServicesMenu') +
        '.png')
    },
    pic2Name() {
      return require('@/assets/documentation/services/' +
        this.$t('documentation.texts.upgradeServices.picUpgradeCuota') +
        '.png')
    },
    pic3Name() {
      return require('@/assets/documentation/services/' +
        this.$t('documentation.texts.upgradeServices.picUpgradePackages') +
        '.png')
    },
    pic4Name() {
      return require('@/assets/documentation/services/' +
        this.$t('documentation.texts.upgradeServices.picShoppingHistory') +
        '.png')
    },
    pic5Name() {
      return require('@/assets/documentation/services/' +
        this.$t('documentation.texts.upgradeServices.picMarkToActivate') +
        '.png')
    },
    pic6Name() {
      return require('@/assets/documentation/services/' +
        this.$t('documentation.texts.upgradeServices.picPurchaseActivated') +
        '.png')
    },
  },
  methods: {
    goDoc(section, subsection = '') {
      if (subsection === '') {
        this.$router.push({
          name: 'DocumentationView',
          query: { section: section },
        })
      } else
        this.$router.push({
          name: 'DocumentationView',
          query: { section: section, subsection },
        })
    },
  },
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}

.custom-link:hover {
  text-decoration: underline;
}

.left-align {
  text-align: left;
}
</style>
